import React, { useState } from 'react'
import styled from 'styled-components'
import { Send } from 'lucide-react'

interface Props {
  onSend: (text: string) => void
  disabled?: boolean
}

const ChatInput: React.FC<Props> = ({ onSend, disabled }) => {
  const [value, setValue] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (value.trim() && !disabled) {
      onSend(value.trim())
      setValue('')
    }
  }

  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKey}
        placeholder={disabled ? 'Piedad está respondiendo...' : 'Escribe tu pregunta...'}
        disabled={disabled}
        rows={1}
      />
      <SendBtn type="submit" disabled={!value.trim() || disabled}>
        <Send size={18} />
      </SendBtn>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(152, 1, 46, 0.3);
  background: rgba(0, 0, 0, 0.4);
`

const Input = styled.textarea`
  flex: 1;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(152, 1, 46, 0.3);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  color: #f1f1f1;
  font-size: 0.9rem;
  resize: none;
  font-family: inherit;
  outline: none;
  &:focus { border-color: #98012E; box-shadow: 0 0 0 2px rgba(152, 1, 46, 0.2); }
  &::placeholder { color: rgba(255, 255, 255, 0.4); }
  &:disabled { opacity: 0.5; }
`

const SendBtn = styled.button`
  background: linear-gradient(135deg, #98012E, #b5133f);
  border: none;
  border-radius: 8px;
  color: white;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:disabled { opacity: 0.3; cursor: not-allowed; }
  &:hover:not(:disabled) { background: linear-gradient(135deg, #b5133f, #d4264f); }
`

export default ChatInput
